export const msMY: { [k: string]: string } = {
  
}
